import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';

export default function InviteModal(props) {
    const [email, setEmail] = useState('');
    const [insultMother, setInsultMother] = useState(false);

    const handleInvite = () => {
        const subject = encodeURIComponent("Hi Dickhead");
        let bodyText = "Come play sumochess with me at sumochess.com.";
        if (insultMother) {
             bodyText += "\nYour mums so fat when she fell in love she broke it";
        }
        const body = encodeURIComponent(bodyText);
        window.location.href = `mailto:${email}?subject=${subject}&body=${body}`;
        props.onHide();
    };

    return (
        <Modal
            contentClassName="bg-dark text-white"
            show={props.show}
            onHide={props.onHide}
            centered>
            <Modal.Header closeButton closeVariant="white">
                <Modal.Title style={{ letterSpacing: 1, fontWeight: 300, fontSize: '1.2rem' }}>
                    Invite someone you hate to play a game of sumochess with you
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group className="mb-4 mt-2">
                    <Form.Control 
                        type="email" 
                        placeholder="Enemy's email address" 
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="bg-dark text-white border-secondary"
                    />
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Check 
                        type="checkbox" 
                        id="insult-mother-checkbox"
                        label="Also insult their mother in the email" 
                        checked={insultMother}
                        onChange={(e) => setInsultMother(e.target.checked)}
                    />
                </Form.Group>
            </Modal.Body>
            <Modal.Footer style={{ borderTop: 'none', justifyContent: 'flex-end' }}>
                <Button variant="danger" onClick={handleInvite}>
                    invite
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
